import * as React from 'react';

export const SkipLink = () =>
    <a href={'#tresc'} className={'skip-link'}>Przejdź do treści</a>

export default SkipLink
